import * as Sentry from '@sentry/react';

// Logger utility for consistent logging across the app
const isDevelopment = process.env.NODE_ENV === 'development';

const LOG_LEVELS = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
};

const normalizeLevel = (level) => {
  if (!level) return null;
  return level.toString().toLowerCase();
};

const defaultLevel = normalizeLevel(
  process.env.REACT_APP_LOG_LEVEL || (isDevelopment ? 'warn' : 'warn')
);

const currentLevelValue =
  LOG_LEVELS[defaultLevel] !== undefined ? LOG_LEVELS[defaultLevel] : LOG_LEVELS.warn;

const shouldLog = (levelKey) => {
  const levelValue = LOG_LEVELS[levelKey];
  if (levelValue === undefined) {
    return false;
  }

  if (levelKey === 'error') {
    return true;
  }

  if (!isDevelopment && levelValue < LOG_LEVELS.warn) {
    return false;
  }

  return levelValue >= currentLevelValue;
};

class Logger {
  info(message, data = null) {
    if (shouldLog('info')) {
      if (data) {
        console.info(`[INFO] ${message}`, data);
      } else {
        console.info(`[INFO] ${message}`);
      }
    }
  }

  warn(message, data = null) {
    if (shouldLog('warn')) {
      if (data) {
        console.warn(`[WARN] ${message}`, data);
      } else {
        console.warn(`[WARN] ${message}`);
      }
    }
  }

  error(message, error = null) {
    if (error) {
      console.error(`[ERROR] ${message}`, error);
    } else {
      console.error(`[ERROR] ${message}`);
    }

    if (error instanceof Error) {
      Sentry.captureException(error, { extra: { message } });
    } else {
      Sentry.captureMessage(message, { level: 'error', extra: { error } });
    }
  }

  debug(message, data = null) {
    if (shouldLog('debug')) {
      if (data) {
        console.debug(`[DEBUG] ${message}`, data);
      } else {
        console.debug(`[DEBUG] ${message}`);
      }
    }
  }
}

export const logger = new Logger();
export default logger;
